import React from 'react';
import logo from '../../images/logo-header.png';

const BannerHead = ({ title }) => (
  <div className="dashboard-bg settlement-dashboardbg">
    <div className="col s12">
      <img className="responsive-img header-img-mobile" src={logo} alt="" />
      <h3>{title}</h3>
    </div>
    <div className="col s8 offset-s1">
      <ul className="tabs">
        <li className="indicator" />
      </ul>
    </div>
  </div>
);

export default BannerHead;
